import type { TextLocalisation } from './en';

export const finnishLocalisation: TextLocalisation = {
  invalidInput: 'Kortin tiedot ovat virheelliset tai tyhjät',
  networkIssue:
    'Yhteyttä ei pystytä muodostamaan {brand} kanssa. Tarkista internet-yhteytesi ja kokeile uudestaan',
  unknownIssue: 'Jotain meni pieleen',
  cardRefused: 'Pankkisi ei hyväksynyt korttia',
  payButton: 'Lisää kortti',
  checkoutTitle: 'Maksa',
  checkoutCancel: 'Peruuta',
  checkoutHeader: '{amount} yritykselle {merchant}',
  checkoutPay: 'Maksa',
  closeButton: 'Sulje',
  poweredBy: 'Powered by',
  tryAgain: 'Yritä uudelleen',
  unexpectedAuthorisation: 'Pankki ei tue kortin vahvistamista. Ole yhteydessä asiakastukeen.',
  'creditCard.numberField.title': 'Kortin numero',
  'creditCard.numberField.placeholder': 'Kortin numero',
  'creditCard.numberField.invalid': 'Virheellinen kortin numero',
  'creditCard.expiryDateField.title': 'Voimassa',
  'creditCard.expiryDateField.placeholder': 'KK/VV',
  'creditCard.expiryDateField.invalid': 'Virheellinen voimassaoloaika',
  'creditCard.expiryDateField.month': 'Kuukausi',
  'creditCard.expiryDateField.month.placeholder': 'KK',
  'creditCard.expiryDateField.year.placeholder': 'VV',
  'creditCard.expiryDateField.year': 'Vuosi',
  'creditCard.cvcField.title': 'CVC / CVV',
  'creditCard.cvcField.placeholder': '123',
  'creditCard.oneClickVerification.invalidInput.title': 'Virheellinen CVC / CVV',
  'creditCard.cvcField.placeholder.3digits': '3 numeroa',
  'error.title': 'Jotain meni pieleen',
  'error.subtitle.redirect': 'Jotain meni pieleen',
  'error.subtitle.payment': 'Maksu epäonnistui',
  'error.subtitle.refused': 'Maksu epäonnistui',
  'error.message.unknown': 'Jotain meni pieleen',
  'error.va.gen.01': 'Tämä kenttä on pakollinen',
  'error.va.gen.02': 'Kentässä on jokin virhe',
  'error.va.sf-cc-num.01': 'Virheellinen kortin numero',
  'error.va.sf-cc-num.02': 'Tämä kortin numero ei vastaa kortin tyyppiä',
  'error.va.sf-cc-num.03': 'Korttia ei tueta',
  'error.va.sf-cc-dat.01': 'Kortti on vanhentunut',
  'error.va.sf-cc-dat.02': 'Päivämäärä on liian kaukana tulevaisuudessa',
  'fscp.error.payment-failed': 'Maksu epäonnistui',
  'fscp.error.timeout': 'Määräaika kului umpeen',
  'fscp.error.message.timeout': 'Maksu jäi odottamaan liian pitkäksi aikaa. Yritä uudelleen.',
  'fscp.error.unknown': 'Jotain meni pieleen',
  'fscp.error.message.insufficientFunds':
    'Kortilla ei ole tarpeeksi rahaa. Kokeile toista korttia.',
  'fscp.error.message.invalidCard': 'Kortti hylättiin.',
  'creditCard.encryptedCardNumber.aria.iframeTitle': 'Kortin numero',
  'creditCard.encryptedCardNumber.aria.label': 'Kortin numero',
  'creditCard.encryptedExpiryDate.aria.iframeTitle': 'Voimassaoloaika',
  'creditCard.encryptedExpiryDate.aria.label': 'Voimassaoloaika',
  'creditCard.encryptedExpiryMonth.aria.iframeTitle': 'Päättymiskuukausi',
  'creditCard.encryptedExpiryMonth.aria.label': 'Päättymiskuukausi',
  'creditCard.encryptedExpiryYear.aria.iframeTitle': 'Päättymisvuosi',
  'creditCard.encryptedExpiryYear.aria.label': 'Päättymisvuosi',
  'creditCard.encryptedSecurityCode.aria.iframeTitle': 'Turvanumero',
  'creditCard.encryptedSecurityCode.aria.label': ' Turvanumero',
  abortFailed: 'Maksun peruutus epäonnistui.',
};
